import { createContext } from 'react'

export interface AuthContextValue {
  token: string | null
  hasAccess: boolean
  isLoading: boolean
  setToken: (token: string | null) => void
  markHasAccess: () => void
  markNoAccess: () => void
  redirectToLogin: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
